import { api } from '.';
import { DefaultResponse } from '../helpers/types';
import {
  CreatePaymentDocumentPayload,
  DefaultDictionary,
  PaymentDocumentItemResponse,
  PaymentDocumentsParams,
  PaymentDocumentsResponse,
} from './types';

export const paymentsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPaymentsCodes: build.query<
      DefaultResponse<DefaultDictionary<'id'>[]>,
      void
    >({
      query: () => ({
        url: '/payments/paymentTypes',
        method: 'GET',
      }),
    }),
    getPurposeCodes: build.query<DefaultResponse<DefaultDictionary[]>, void>({
      query: () => ({
        url: '/payments/purposeCodes',
        method: 'POST',
      }),
    }),
    createPaymentsDocument: build.mutation<void, CreatePaymentDocumentPayload>({
      query: (body) => ({
        url: '/payments/document',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['FactorDeal'],
    }),
    getPaymentsDocuments: build.query<
      DefaultResponse<PaymentDocumentsResponse> & { totalPages: number },
      PaymentDocumentsParams
    >({
      query: (body) => ({
        url: '/payments/documents',
        method: 'POST',
        body,
      }),
    }),
    getPaymentsDocumentItem: build.query<
      DefaultResponse<PaymentDocumentItemResponse>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `/payments/document/${id}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetPaymentsCodesQuery,
  useCreatePaymentsDocumentMutation,
  useGetPurposeCodesQuery,
  useGetPaymentsDocumentsQuery,
  useGetPaymentsDocumentItemQuery,
} = paymentsApi;
